import React from "react";

/**
 * Reusable Section Heading Component
 * @param {string} title - The heading text
 * @param {string} className - Additional CSS classes
 */
const SectionHeading = ({ title, className = "" }) => (
  <div className={`text-center mb-5 ${className}`}>
    <h2 className="fw-bold">{title}</h2>
    <div className="underline"></div>
  </div>
);

export default SectionHeading;
